<div class="content-area">
  <div class="title-block">
    <div class="title-block__left">
      <h1>Onboarding</h1>
    </div>
  </div>

  <div class="sync-page-outer">
    <div class="sync-page-outer__import">
      <form class="form">
        <div class="col">
          <div class="sync-page-outer__block">
            <div class="from__group">
              <label class="form__label">Appointment</label>
              <div class="import__block__left__column-right">
                <button class="btn btn--download" (click)="downloadTemplate()">
                  <i class="ic download"></i>
                  Download Template
                </button>
                <div class="browse-import-btn">
                  <div>
                    <input type="file" #appointmentFile style="display: none" (change)="selectFile(appointmentFile.files)" />
                    <button class="btn btn--primary" (click)="appointmentFile.value = ''; selectedFile = null; appointmentFile.click()">Browse</button>
                    <button class="btn btn--primary" (click)="verifyFile()" [disabled]="!selectedFile">Process</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="on-boarding-table">
      <div class="table-outer-main">
        <h3>Onboarding History</h3>
        <div class="on-boarding-table-table">
          <p-table class="table-outer" [value]="items" sortMode="single" sortField="app_OnboardId" scrollHeight="calc(100vh - 380px)" responsiveLayout="scroll">
            <ng-template pTemplate="header">
              <tr>
                <th class="table-outer__th" width="600" pSortableColumn="app_UploadFile">Upload File Name<p-sortIcon field="UploadFilePath"></p-sortIcon></th>
                <th class="table-outer__th" pSortableColumn="dateTimeCreated">Process Date<p-sortIcon field="processdate"></p-sortIcon></th>
                <th class="table-outer__th verifydate" pSortableColumn="app_SucessCount">Verify Data Count<p-sortIcon field="SucessCount"></p-sortIcon></th>
                <th class="table-outer__th verifydate" pSortableColumn="app_BadCount">Bad Data Count<p-sortIcon field="BadCount"></p-sortIcon></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-history>
              <tr>
                <td class="table-outer__td">
                  <span class="link">
                    <a (click)="downloadFile(history.onboardId, history.uploadFile)">
                      {{ history.uploadFile }}
                    </a>
                  </span>
                </td>
                <td class="table-outer__td">
                  <span class="processDate">
                    {{ history.dateTimeCreated | date : 'MM/dd/yyyy hh:mm a' }}
                  </span>
                </td>
                <td class="table-outer__td verifydate">
                  <span class="sucessCount">
                    {{ history.sucessDataCount }}
                  </span>
                </td>
                <td class="table-outer__td verifydate">
                  <span class="badCount">
                    {{ history.badDataCount }}
                  </span>
                </td>
              </tr>
            </ng-template>
          </p-table>
          <div class="loader-block" *ngIf="loading">
            <p-progressSpinner [style]="{ width: '50px', height: '50px' }" strokeWidth="8" fill="#ffffff" animationDuration=".8s"> </p-progressSpinner>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
